import React from 'react';
import { format } from 'date-fns';
import { Chip } from '@mui/material';

const truncateText = (text: string, maxLength: number = 50) => {
  if (!text) return '-';
  return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
};

export const projectCommunicationsColumns = (onRowClick?: (row: any) => void) => [
  {
    name: 'Customer',
    selector: (row) => row.customer,
    sortable: true,
    grow: 2,
    cell: (row) => (
      <div onClick={() => onRowClick?.(row)} style={{ cursor: 'pointer', width: '100%' }}>
        {truncateText(row.customer, 40)}
      </div>
    ),
  },
  {
    name: 'Job',
    selector: (row) => row.job,
    sortable: true,
    width: '120px',
    cell: (row) => (
      <div onClick={() => onRowClick?.(row)} style={{ cursor: 'pointer', width: '100%' }}>
        {row.job || '-'}
      </div>
    ),
  },
  {
    name: 'Department',
    selector: (row) => row.department,
    sortable: true,
    grow: 1,
    cell: (row) => (
      <div onClick={() => onRowClick?.(row)} style={{ cursor: 'pointer', width: '100%' }}>
        {truncateText(row.department, 20)}
      </div>
    ),
  },
  {
    name: 'Status',
    selector: (row) => row.status,
    sortable: true,
    width: '150px',
    cell: (row) => (
      <Chip
        label={row.status || 'N/A'}
        color={row.has_status ? 'success' : 'default'}
        size="small"
        onClick={() => onRowClick?.(row)}
        sx={{ cursor: 'pointer' }}
      />
    ),
  },
  {
    name: 'Opened',
    selector: (row) => row.opened,
    sortable: true,
    width: '110px',
    cell: (row) => (
      <div onClick={() => onRowClick?.(row)} style={{ cursor: 'pointer', width: '100%' }}>
        {row.opened ? format(new Date(row.opened), 'MM/dd/yy') : '-'}
      </div>
    ),
  },
  {
    name: 'Age',
    selector: (row) => row.age,
    sortable: true,
    width: '80px',
    cell: (row) => (
      <div onClick={() => onRowClick?.(row)} style={{ cursor: 'pointer', width: '100%' }}>
        {`${row.age}d`}
      </div>
    ),
  },
  {
    name: 'Salesperson',
    selector: (row) => row.salesperson,
    sortable: true,
    grow: 1,
    cell: (row) => (
      <div onClick={() => onRowClick?.(row)} style={{ cursor: 'pointer', width: '100%' }}>
        {row.salesperson || '-'}
      </div>
    ),
  },
  {
    name: 'Last Comm',
    selector: (row) => row.last_communication,
    sortable: true,
    width: '110px',
    cell: (row) => (
      <div onClick={() => onRowClick?.(row)} style={{ cursor: 'pointer', width: '100%' }}>
        {row.last_communication ? format(new Date(row.last_communication), 'MM/dd/yy') : '-'}
      </div>
    ),
  },
  {
    name: 'Location',
    selector: (row) => row.db_location,
    sortable: true,
    width: '100px',
    cell: (row) => (
      <Chip
        label={row.db_location === 'pittsburgh' ? 'PGH' : 'TPA'}
        color={row.db_location === 'pittsburgh' ? 'primary' : 'secondary'}
        size="small"
        onClick={() => onRowClick?.(row)}
        sx={{ cursor: 'pointer' }}
      />
    ),
  },
];
